export const ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_HISTORY_CHANGES_EDIT_ROUTE_NAME = Symbol('admin.affiliates.approved.trackers-settings.trackers.history-changes-edit');

export const TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_TRACKERS_HISTORY_CHANGES_EDIT = Symbol('admin.affiliates.approved.trackers-settings.trackers.history-changes-edit');

export const TRACKER_HISTORY_CHANGES_ITEM_QUERY = 'affiliate.tracker-history-changes-item';
export const TRACKER_HISTORY_CHANGES_ITEM_API_URL = 'admin/history_of_trackers_changes/:itemId/edit';

export const TRACKER_HISTORY_CHANGES_ITEM_UPDATE_MUTATION = 'affiliate.tracker-history-changes-item-update';
export const TRACKER_HISTORY_CHANGES_ITEM_UPDATE_API_URL = 'admin/history_of_trackers_changes/:itemId';
